import { gql } from 'apollo-angular'

export default gql`
  mutation edit_user_by_pk($id: Int!, $_set: user_set_input) {
    update_user(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
